export default __webpack_public_path__ + "static/media/portfolio-8.c9875509.jpg";